var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContainerFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5667 6.92667L13.2733 6.22C13.7933 5.7 13.7933 4.85333 13.2733 4.33333L12.3333 3.39333C11.8133 2.87333 10.9667 2.87333 10.4467 3.39333L9.74 4.1L12.5667 6.92667ZM8.79333 5.04L2.66667 11.1733V14H5.49333L11.62 7.87333L8.79333 5.04ZM12.6667 11.6667C12.6667 13.1267 10.9733 14 9.33333 14C8.96667 14 8.66667 13.7 8.66667 13.3333C8.66667 12.9667 8.96667 12.6667 9.33333 12.6667C10.36 12.6667 11.3333 12.18 11.3333 11.6667C11.3333 11.3533 11.0133 11.0867 10.5133 10.8667L11.5 9.88C12.2133 10.3 12.6667 10.86 12.6667 11.6667ZM3.05333 8.9C2.40667 8.52667 2 8.04 2 7.33333C2 6.13333 3.26 5.58 4.37333 5.09333C5.06 4.78667 6 4.37333 6 4C6 3.72667 5.48 3.33333 4.66667 3.33333C3.82667 3.33333 3.46667 3.74 3.44667 3.76C3.21333 4.03333 2.79333 4.06667 2.51333 3.84C2.37935 3.7304 2.29379 3.57255 2.27508 3.40046C2.25637 3.22838 2.30603 3.05583 2.41333 2.92C2.48667 2.82667 3.17333 2 4.66667 2C6.16 2 7.33333 2.88 7.33333 4C7.33333 5.24667 6.04667 5.81333 4.90667 6.31333C4.28 6.58667 3.33333 7 3.33333 7.33333C3.33333 7.54 3.62 7.73333 4.04667 7.90667L3.05333 8.9Z",
    fill: "#A0A8AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContainerFigma);
export default __webpack_public_path__ + "static/media/Icon Container Figma.1ac18ee6632edc7436db895468429f90.svg";
export { ForwardRef as ReactComponent };